// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vn2yTB {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  background: transparent;
}

.vn2yTB th {
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  background: transparent;
  padding: var(--spacing-1-5) var(--spacing-1);
  text-align: left;
  border-bottom: 1px solid var(--surface-neutral-soft);
}

.vn2yTB td {
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  padding: var(--spacing-1-5) var(--spacing-1);
  background: transparent;
  vertical-align: middle;
}

.uTj3x_ {
  background: var(--background-white);
}

.uTj3x_:nth-child(even) {
  background: var(--background-alt);
}

.Rq5btM {
  display: inline-block;
  padding: var(--spacing-0) var(--spacing-1-5);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--status-info);
  background: color-mix(in srgb, var(--status-info) 10%, transparent);
  border: 1px solid var(--status-info);
  border-radius: var(--radius-pill);
  line-height: 1.6em;
}

.guJzXo {
  display: inline-block;
  padding: var(--spacing-0) var(--spacing-1-5);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--status-success);
  background: color-mix(in srgb, var(--status-success) 10%, transparent);
  border: 1px solid var(--status-success);
  border-radius: var(--radius-pill);
  line-height: 1.6em;
}

.L8iBDI {
  display: inline-block;
  padding: var(--spacing-0) var(--spacing-1-5);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--status-warning);
  background: color-mix(in srgb, var(--status-warning) 10%, transparent);
  border: 1px solid var(--status-warning);
  border-radius: var(--radius-pill);
  line-height: 1.6em;
}

.IHDjVP {
  display: inline-block;
  padding: var(--spacing-0) var(--spacing-1-5);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--status-error);
  background: color-mix(in srgb, var(--status-error) 10%, transparent);
  border: 1px solid var(--status-error);
  border-radius: var(--radius-pill);
  line-height: 1.6em;
}

.uynp9y {
  position: relative;
  width: 60px;
}

.Kbdseb {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.WlxwfH {
  padding: 0;
  min-width: var(--spacing-4);
  height: var(--spacing-4);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-s);
  background: transparent;
  border: none;
  cursor: pointer;
}

.W0Zalm {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  z-index: 1000;
}

/* Responsiveness for table */
@media (max-width: var(--grid-breakpoint-xs)) {
  .vn2yTB th,
  .vn2yTB td {
    padding: var(--spacing-1) var(--spacing-0-5);
    font-size: var(--font-size-sm);
  }
  .WlxwfH {
    min-width: calc(var(--spacing-4) - var(--spacing-0-5));
    height: calc(var(--spacing-4) - var(--spacing-0-5));
  }
}
.Sj7h6v {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.RAXME_ {
  background: var(--background-white);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.aa6V9u {
  display: flex;
  align-items: flex-end;
  padding: var(--spacing-3) var(--spacing-1-5) 0px var(--spacing-3);
  border-bottom: 1px solid var(--surface-neutral-soft);
}

.KQRJzb {
  display: flex;
  flex: 1;
}

.J6iYCQ {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 var(--spacing-2);
  border-bottom: 3px solid var(--brand-tr-orange);
}

.itDav2 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: 1em;
  color: var(--brand-tr-orange);
}

.s8sPSx {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: var(--spacing-3);
  overflow-y: auto;
  max-height: 600px;
}

.uqo1vH {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
  gap: var(--spacing-3);
}

.FXEJGg {
  display: flex;
  align-items: center;
  justify-content: center;
}

.GG5xPf {
  width: var(--spacing-9);
  height: var(--spacing-9);
  border-radius: var(--radius-pill);
  background: color-mix(in srgb, var(--brand-tr-orange) 10%, transparent);
  display: flex;
  align-items: center;
  justify-content: center;
}

.DytYPY {
  width: calc(var(--spacing-2) - 0.5px);
  height: calc(var(--spacing-2) - 0.5px);
  color: var(--brand-tr-orange);
}

.my1c08 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-1);
  max-width: calc(var(--spacing-3) * 11.25); /* 270px equivalent */
}

.IsOK1J {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: 1.8em;
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: center;
}

.UkQiBw {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: 1.8em;
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: center;
}

.PXN3Da {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  margin-top: var(--spacing-1);
  padding: var(--spacing-1-5) var(--spacing-2);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: 1.424em;
}

/* Responsiveness */
@media (max-width: var(--grid-breakpoint-xs)) {
  .uqo1vH {
    padding: var(--spacing-4) var(--spacing-2);
  }

  .GG5xPf {
    width: calc(var(--spacing-8) - var(--spacing-0-5));
    height: calc(var(--spacing-8) - var(--spacing-0-5));
  }

  .DytYPY {
    width: var(--spacing-3);
    height: var(--spacing-3);
  }

  .my1c08 {
    gap: var(--spacing-1-5);
  }
}

.QY7WC4 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-4);
}

.gyoSh6 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-4);
  color: var(--status-error);
  font-weight: var(--font-weight-medium);
  text-align: center;
}

.wX22RP {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-3);
  border-top: 1px solid var(--surface-neutral-soft);
  background: var(--background-white);
}

.pkR6Bn {
  height: 1px;
  width: 100%;
}

.RF741u {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-3);
  color: var(--text-neutral-stronger);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  border-top: 1px solid var(--surface-neutral-soft);
  background: var(--background-alt);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ChargesList/ChargesList.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,uBAAuB;EACvB,4CAA4C;EAC5C,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,4CAA4C;EAC5C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,mEAAmE;EACnE,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,8BAA8B;EAC9B,uCAAuC;EACvC,4BAA4B;EAC5B,sEAAsE;EACtE,uCAAuC;EACvC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,8BAA8B;EAC9B,uCAAuC;EACvC,4BAA4B;EAC5B,sEAAsE;EACtE,uCAAuC;EACvC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,8BAA8B;EAC9B,uCAAuC;EACvC,0BAA0B;EAC1B,oEAAoE;EACpE,qCAAqC;EACrC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE;;IAEE,4CAA4C;IAC5C,8BAA8B;EAChC;EACA;IACE,sDAAsD;IACtD,mDAAmD;EACrD;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iEAAiE;EACjE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,uEAAuE;EACvE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC,EAAE,qBAAqB;AAClE;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,kBAAkB;EAClB,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,4CAA4C;EAC5C,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,kDAAkD;IAClD,mDAAmD;EACrD;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,iDAAiD;EACjD,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,8BAA8B;EAC9B,uCAAuC;EACvC,iDAAiD;EACjD,iCAAiC;AACnC","sourcesContent":[".table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  background: transparent;\n}\n\n.table th {\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  background: transparent;\n  padding: var(--spacing-1-5) var(--spacing-1);\n  text-align: left;\n  border-bottom: 1px solid var(--surface-neutral-soft);\n}\n\n.table td {\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  padding: var(--spacing-1-5) var(--spacing-1);\n  background: transparent;\n  vertical-align: middle;\n}\n\n.tableRow {\n  background: var(--background-white);\n}\n\n.tableRow:nth-child(even) {\n  background: var(--background-alt);\n}\n\n.badgeInfo {\n  display: inline-block;\n  padding: var(--spacing-0) var(--spacing-1-5);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--status-info);\n  background: color-mix(in srgb, var(--status-info) 10%, transparent);\n  border: 1px solid var(--status-info);\n  border-radius: var(--radius-pill);\n  line-height: 1.6em;\n}\n\n.badgeSuccess {\n  display: inline-block;\n  padding: var(--spacing-0) var(--spacing-1-5);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--status-success);\n  background: color-mix(in srgb, var(--status-success) 10%, transparent);\n  border: 1px solid var(--status-success);\n  border-radius: var(--radius-pill);\n  line-height: 1.6em;\n}\n\n.badgeWarning {\n  display: inline-block;\n  padding: var(--spacing-0) var(--spacing-1-5);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--status-warning);\n  background: color-mix(in srgb, var(--status-warning) 10%, transparent);\n  border: 1px solid var(--status-warning);\n  border-radius: var(--radius-pill);\n  line-height: 1.6em;\n}\n\n.badgeError {\n  display: inline-block;\n  padding: var(--spacing-0) var(--spacing-1-5);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--status-error);\n  background: color-mix(in srgb, var(--status-error) 10%, transparent);\n  border: 1px solid var(--status-error);\n  border-radius: var(--radius-pill);\n  line-height: 1.6em;\n}\n\n.actionCell {\n  position: relative;\n  width: 60px;\n}\n\n.actionContainer {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.actionButton {\n  padding: 0;\n  min-width: var(--spacing-4);\n  height: var(--spacing-4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-s);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.actionMenu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 4px;\n  z-index: 1000;\n}\n\n/* Responsiveness for table */\n@media (max-width: var(--grid-breakpoint-xs)) {\n  .table th,\n  .table td {\n    padding: var(--spacing-1) var(--spacing-0-5);\n    font-size: var(--font-size-sm);\n  }\n  .actionButton {\n    min-width: calc(var(--spacing-4) - var(--spacing-0-5));\n    height: calc(var(--spacing-4) - var(--spacing-0-5));\n  }\n}\n.container {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.card {\n  background: var(--background-white);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-card);\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.header {\n  display: flex;\n  align-items: flex-end;\n  padding: var(--spacing-3) var(--spacing-1-5) 0px var(--spacing-3);\n  border-bottom: 1px solid var(--surface-neutral-soft);\n}\n\n.tabsGroup {\n  display: flex;\n  flex: 1;\n}\n\n.activeTab {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0 0 var(--spacing-2);\n  border-bottom: 3px solid var(--brand-tr-orange);\n}\n\n.tabTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: 1em;\n  color: var(--brand-tr-orange);\n}\n\n.tableContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: var(--spacing-3);\n  overflow-y: auto;\n  max-height: 600px;\n}\n\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  text-align: center;\n  gap: var(--spacing-3);\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.iconBackground {\n  width: var(--spacing-9);\n  height: var(--spacing-9);\n  border-radius: var(--radius-pill);\n  background: color-mix(in srgb, var(--brand-tr-orange) 10%, transparent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  width: calc(var(--spacing-2) - 0.5px);\n  height: calc(var(--spacing-2) - 0.5px);\n  color: var(--brand-tr-orange);\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-1);\n  max-width: calc(var(--spacing-3) * 11.25); /* 270px equivalent */\n}\n\n.emptyTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: 1.8em;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: center;\n}\n\n.emptyDescription {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: 1.8em;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: center;\n}\n\n.ctaButton {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  margin-top: var(--spacing-1);\n  padding: var(--spacing-1-5) var(--spacing-2);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: 1.424em;\n}\n\n/* Responsiveness */\n@media (max-width: var(--grid-breakpoint-xs)) {\n  .emptyState {\n    padding: var(--spacing-4) var(--spacing-2);\n  }\n\n  .iconBackground {\n    width: calc(var(--spacing-8) - var(--spacing-0-5));\n    height: calc(var(--spacing-8) - var(--spacing-0-5));\n  }\n\n  .icon {\n    width: var(--spacing-3);\n    height: var(--spacing-3);\n  }\n\n  .content {\n    gap: var(--spacing-1-5);\n  }\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-4);\n}\n\n.errorMessage {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-4);\n  color: var(--status-error);\n  font-weight: var(--font-weight-medium);\n  text-align: center;\n}\n\n.infiniteLoadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-3);\n  border-top: 1px solid var(--surface-neutral-soft);\n  background: var(--background-white);\n}\n\n.scrollTrigger {\n  height: 1px;\n  width: 100%;\n}\n\n.endOfListIndicator {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-3);\n  color: var(--text-neutral-stronger);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  border-top: 1px solid var(--surface-neutral-soft);\n  background: var(--background-alt);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `vn2yTB`,
	"tableRow": `uTj3x_`,
	"badgeInfo": `Rq5btM`,
	"badgeSuccess": `guJzXo`,
	"badgeWarning": `L8iBDI`,
	"badgeError": `IHDjVP`,
	"actionCell": `uynp9y`,
	"actionContainer": `Kbdseb`,
	"actionButton": `WlxwfH`,
	"actionMenu": `W0Zalm`,
	"container": `Sj7h6v`,
	"card": `RAXME_`,
	"header": `aa6V9u`,
	"tabsGroup": `KQRJzb`,
	"activeTab": `J6iYCQ`,
	"tabTitle": `itDav2`,
	"tableContent": `s8sPSx`,
	"emptyState": `uqo1vH`,
	"iconContainer": `FXEJGg`,
	"iconBackground": `GG5xPf`,
	"icon": `DytYPY`,
	"content": `my1c08`,
	"emptyTitle": `IsOK1J`,
	"emptyDescription": `UkQiBw`,
	"ctaButton": `PXN3Da`,
	"loadingContainer": `QY7WC4`,
	"errorMessage": `gyoSh6`,
	"infiniteLoadingContainer": `wX22RP`,
	"scrollTrigger": `pkR6Bn`,
	"endOfListIndicator": `RF741u`
};
module.exports = ___CSS_LOADER_EXPORT___;
